(function () {
  'use strict';

  const DATA = window.LawazenTrotecData;
  if (!DATA) return;

  const $ = (sel, root = document) => root.querySelector(sel);
  const $$ = (sel, root = document) => Array.from(root.querySelectorAll(sel));
  const esc = (value = '') => String(value).replace(/[&<>'"]/g, (char) => ({
    '&': '&amp;', '<': '&lt;', '>': '&gt;', "'": '&#039;', '"': '&quot;'
  })[char]);

  const isRtl = () => document.documentElement.dir === 'rtl' || (document.documentElement.lang || '').toLowerCase().startsWith('ar');

  const STORAGE_KEY = 'lawazenTrotecFinderStateV1';

  const translations = {
    en: {
      back: 'Back', continue: 'Continue', restart: 'Start over', results: 'Your recommendation',
      bestMatch: 'Best match', alternatives: 'Strong alternatives', why: 'Why this fits',
      extraction: 'Extraction configuration', safety: 'Safety & validation', documents: 'Documentation',
      request: 'Request a Lawazen consultation', viewProduct: 'View / find product', officialDocs: 'Official Trotec docs',
      findMaterials: 'Find materials for this machine', findMachine: 'Find a machine for this material',
      answerSummary: 'Your application summary', specialist: 'Specialist review required',
      noAuto: 'The wizard will not make an automatic processing recommendation for this material.',
      fit: 'Fit', active: 'Available from Lawazen / listed', availability: 'Ask Lawazen about availability',
      close: 'Close', selected: 'Selected', none: 'None selected', optional: 'Optional'
    },
    ar: {
      back: 'رجوع', continue: 'متابعة', restart: 'ابدأ من جديد', results: 'التوصية المناسبة لك',
      bestMatch: 'أفضل تطابق', alternatives: 'بدائل قوية', why: 'لماذا يناسبك',
      extraction: 'نظام الشفط والترشيح', safety: 'السلامة والتحقق', documents: 'المستندات',
      request: 'اطلب استشارة من لوازن', viewProduct: 'عرض / البحث عن المنتج', officialDocs: 'مستندات تروتك الرسمية',
      findMaterials: 'ابحث عن مواد لهذه الماكينة', findMachine: 'ابحث عن ماكينة لهذه المادة',
      answerSummary: 'ملخص تطبيقك', specialist: 'يتطلب مراجعة فنية',
      noAuto: 'لن يقدم المعالج توصية تشغيل تلقائية لهذه المادة.',
      fit: 'التوافق', active: 'متوفر / مدرج لدى لوازن', availability: 'اسأل لوازن عن التوفر',
      close: 'إغلاق', selected: 'تم الاختيار', none: 'لا يوجد اختيار', optional: 'اختياري'
    }
  };

  const T = translations[isRtl() ? 'ar' : 'en'];

  function icon(name) {
    const paths = {
      'graduation-cap': '<path d="M2 7.5 12 3l10 4.5L12 12 2 7.5Zm4 2.2V15c3.8 2.8 8.2 2.8 12 0V9.7M21 9v6"/>',
      factory: '<path d="M3 21V10l6 3V9l6 4V6h6v15H3Zm4-3h2m3 0h2m3 0h2"/>',
      shield: '<path d="M12 3 20 6v6c0 5-3.5 8-8 9-4.5-1-8-4-8-9V6l8-3Zm-3 9 2 2 4-5"/>',
      sign: '<path d="M5 4h13l2 4-2 4H5L3 8l2-4Zm7 8v9M8 21h8"/>',
      stamp: '<path d="M8 3h8v4c0 2 1 3 3 4v3H5v-3c2-1 3-2 3-4V3Zm-2 14h12v4H6v-4Z"/>',
      sparkles: '<path d="m12 3 1.2 3.8L17 8l-3.8 1.2L12 13l-1.2-3.8L7 8l3.8-1.2L12 3Zm6 9 .8 2.2L21 15l-2.2.8L18 18l-.8-2.2L15 15l2.2-.8L18 12ZM5 13l1 2.8L9 17l-3 1.2L5 21l-1-2.8L1 17l3-1.2L5 13Z"/>',
      help: '<circle cx="12" cy="12" r="9"/><path d="M9.8 9a2.3 2.3 0 1 1 3.4 2c-1 .6-1.2 1-1.2 2M12 17h.01"/>',
      laser: '<path d="M4 5h16v14H4V5Zm3 3h10v5H7V8Zm5 5v3m-3 0h6"/>',
      material: '<path d="m12 3 8 4-8 4-8-4 8-4Zm8 8-8 4-8-4m16 4-8 4-8-4"/>',
      check: '<path d="m5 12 4 4L19 6"/>',
      alert: '<path d="M12 3 2.5 20h19L12 3Zm0 6v5m0 3h.01"/>',
      arrow: isRtl() ? '<path d="m14 6-6 6 6 6"/>' : '<path d="m10 6 6 6-6 6"/>',
      ruler: '<path d="M4 17 17 4l3 3L7 20H4v-3Zm8-8 3 3m-6 0 3 3m-6 0 3 3"/>',
      database: '<ellipse cx="12" cy="5" rx="7" ry="3"/><path d="M5 5v6c0 1.7 3.1 3 7 3s7-1.3 7-3V5M5 11v6c0 1.7 3.1 3 7 3s7-1.3 7-3v-6"/>'
    };
    return `<svg class="lz-icon" viewBox="0 0 24 24" aria-hidden="true" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">${paths[name] || paths.help}</svg>`;
  }

  function parseQuery() {
    const p = new URLSearchParams(window.location.search);
    const state = {};
    ['mode','industry','application','material','process','size','volume','priority','machine','materialProduct','materialEnvironment','materialAppearance','materialProcess'].forEach((key) => {
      if (p.get(key)) state[key] = p.get(key);
    });
    if (p.get('requirements') !== null) state.requirements = p.get('requirements') ? p.get('requirements').split(',').filter(Boolean) : [];
    return state;
  }

  function loadState() {
    let stored = {};
    try { stored = JSON.parse(localStorage.getItem(STORAGE_KEY) || '{}'); } catch (e) { stored = {}; }
    return Object.assign({}, stored, parseQuery());
  }

  function saveState(state) {
    try { localStorage.setItem(STORAGE_KEY, JSON.stringify(state)); } catch (e) {}
  }

  function genericMaterial(id) {
    return DATA.genericMaterials.find((m) => m.id === id);
  }

  function applicationFor(state) {
    const apps = DATA.applications[state.industry] || [];
    return apps.find((a) => a.id === state.application);
  }

  function machineById(id) { return DATA.machines.find((m) => m.id === id); }
  function trotecMaterialById(id) { return DATA.trotecMaterials.find((m) => m.id === id); }

  function processSet(process) {
    if (process === 'cut-engrave') return ['cut','engrave'];
    if (process === 'mixed') return ['cut','engrave','mark'];
    return process ? [process] : [];
  }

  function fitsArea(machine, sizeId) {
    const opt = DATA.sizeOptions.concat(DATA.markSizeOptions || []).find((s) => s.id === sizeId);
    if (!opt || !opt.max) return true;
    const [rw, rh] = opt.max;
    const [mw, mh] = machine.area || [0,0];
    return (mw >= rw && mh >= rh) || (mw >= rh && mh >= rw);
  }

  function requiredTech(state) {
    const mat = genericMaterial(state.material);
    const requested = processSet(state.process);
    if (!mat) return [];
    if (requested.some((p) => ['mark','serialize'].includes(p)) && mat.group === 'metal') return ['fiber','mopa'];
    if (requested.some((p) => ['cut','engrave','printcut'].includes(p)) && mat.co2 && mat.co2.length) return ['co2'];
    return [];
  }

  function hardStop(state) {
    const mat = genericMaterial(state.material);
    if (mat && mat.prohibited) {
      return {
        title: 'PVC is not accepted for laser processing',
        body: 'The Lawazen engineering safety rule treats PVC as a hard stop. Choose a verified PVC-free alternative or ask Lawazen to review the material before processing.',
        type: 'danger'
      };
    }
    if (mat && mat.unknown) {
      return {
        title: 'Material identity must be verified first',
        body: 'For Education/FabLab and professional workflows, unidentified material is not automatically approved. Provide the exact product/material identity and SDS, or request a Lawazen material review/sample test.',
        type: 'warning'
      };
    }
    return null;
  }

  function scoreMachines(state) {
    const stop = hardStop(state);
    if (stop) return { stop, results: [] };

    const app = applicationFor(state);
    const mat = genericMaterial(state.material);
    const reqProcesses = processSet(state.process);
    const requirements = state.requirements || [];

    const rows = DATA.machines.map((m) => {
      let score = 0;
      const reasons = [];
      const cautions = [];
      let excluded = false;

      // Commercial/public priority.
      if (m.active) score += 6;
      if (m.priority === 'primary') score += 4;
      if (m.priority === 'specialist') score -= 2;

      // Industry profile.
      const iw = (m.industries && m.industries[state.industry]) || 0;
      score += iw * 2.1;
      if (iw >= 8) reasons.push(`Strong ${DATA.industries.find(i => i.id === state.industry)?.label || 'industry'} fit`);

      // Application.
      if (app && m.applications.includes(app.id)) {
        score += 24;
        reasons.push(`Designed for workflows like ${app.label.toLowerCase()}`);
      } else if (app) {
        score -= 3;
      }

      // Material compatibility / technology.
      if (state.material === 'mixed') {
        score += m.tech.includes('co2') ? 6 : 2;
      } else if (mat) {
        if (m.materials.includes(mat.id)) {
          score += 22;
          reasons.push(`Matches the selected ${mat.label} workflow`);
        } else {
          const needs = requiredTech(state);
          if (needs.length && needs.some((t) => m.tech.includes(t))) score += 8;
          else score -= 12;
        }
      }

      // Process hard/soft gates.
      reqProcesses.forEach((p) => {
        if (m.processes.includes(p)) {
          score += 16;
        } else if (p === 'mark' && m.processes.includes('mark-compound') && mat && mat.group === 'metal') {
          score += 2;
          cautions.push('CO₂ bare-metal marking uses a marking compound; direct industrial marking usually favors fiber/MOPA.');
        } else if (p === 'serialize' && !m.tech.includes('fiber') && !m.tech.includes('mopa')) {
          score -= 45;
        } else if (p === 'cut' && mat && mat.group === 'metal') {
          excluded = true;
        } else {
          score -= 10;
        }
      });

      // Direct metal marking.
      if (mat && mat.group === 'metal' && reqProcesses.some((p) => ['mark','serialize'].includes(p))) {
        if (m.tech.includes('fiber') || m.tech.includes('mopa')) {
          score += 28;
          reasons.push('Direct fiber marking route for bare-metal work');
        } else if (reqProcesses.includes('serialize')) {
          excluded = true;
        } else if (m.processes.includes('mark-compound')) {
          score -= 5;
        } else {
          excluded = true;
        }
      }

      // Work area.
      if (state.size && state.size !== 'unsure') {
        if (fitsArea(m, state.size)) {
          score += 20;
          reasons.push(`Work area covers the selected size range (${m.areaLabel})`);
        } else {
          excluded = true;
        }
      }

      // Production volume.
      if (state.volume) {
        if (m.volumes.includes(state.volume)) score += 12;
        const volumeWeight = (DATA.volumeOptions.find(v => v.id === state.volume) || {}).weight || 1;
        if (volumeWeight >= 3) score += Math.min(m.automation || 0, 10);
      }

      // Engineering tie-break logic.
      if (state.industry === 'stamps' || state.application === 'stamp-production' || state.application === 'rubber-stamps') {
        if (m.family === 'Speedy') {
          score += 22;
          reasons.push('Speedy is the engineering-preferred family for raster-heavy stamp production');
        }
      }

      if (reqProcesses.includes('cut')) {
        if (m.family === 'Q Series') {
          score += state.priority === 'cutting-throughput' ? 18 : 8;
          reasons.push('Q Series is favored for cutting-heavy CO₂ workflows');
        }
        if (m.family === 'SP Series' && ['sp1500','sheet8x4','very-large'].includes(state.size)) {
          score += 26;
          reasons.push('SP Series is the large-format cutting branch');
        }
      }

      if (reqProcesses.includes('engrave') && m.family === 'Speedy') {
        score += state.priority === 'engraving-speed' ? 20 : 8;
        reasons.push('Speedy is favored for engraving-heavy production');
      }

      if (state.priority === 'value' && m.id === 'r500') {
        score += 20;
        reasons.push('R500 is the value/large-bed branch for new users and education');
      }
      if (state.priority === 'automation') {
        score += (m.automation || 0) * 2;
        if (m.family === 'SpeedMarker') reasons.push('Strong automation / dynamic-data workflow');
      }
      if (state.priority === 'versatility' && m.family === 'Speedy') score += 8;

      // Requirements.
      if (requirements.includes('automation')) {
        score += (m.automation || 0) * 2.5;
        if ((m.automation || 0) < 4) score -= 10;
      }
      if (requirements.includes('printcut')) {
        if (['speedy-300','speedy-400','q400','q500','sp1500'].includes(m.id)) score += 12;
        else score -= 5;
      }
      if (requirements.includes('rotary')) {
        if (['speedy-100r','speedy-300','speedy-400','q400'].includes(m.id)) score += 10;
        else score -= 4;
      }
      if (requirements.includes('mopa')) {
        if (m.tech.includes('mopa')) {
          score += 30;
          reasons.push('MOPA-capable family for the requested thermal-control result');
        } else {
          excluded = true;
        }
      }
      if (requirements.includes('students')) {
        if ((m.class || '').toLowerCase().includes('class 2')) score += 12;
        else score -= 15;
      }

      // U300 vs SpeedMarker practical split.
      if (['mark','serialize'].some((p) => reqProcesses.includes(p))) {
        if (m.id === 'u300' && ['low','medium'].includes(state.volume) && !requirements.includes('automation')) score += 12;
        if (m.id === 'speedmarker-300' && (requirements.includes('automation') || ['high','very-high'].includes(state.volume))) score += 18;
        if (m.id === 'speedmarker-700' && (state.size === 'mark-large' || ['high','very-high'].includes(state.volume))) score += 14;
      }

      // Education should not default to large specialist platforms.
      if (state.industry === 'education' && m.family === 'SP Series') score -= 14;

      // Specialist machines should only win when truly needed.
      if (m.priority === 'specialist' && !['sp1500','sheet8x4','very-large'].includes(state.size)) score -= 18;

      if (excluded) score = -999;
      return { machine: m, score, reasons: Array.from(new Set(reasons)).slice(0, 5), cautions };
    }).filter((r) => r.score > -900);

    rows.sort((a,b) => b.score - a.score);
    const max = rows.length ? rows[0].score : 1;
    rows.forEach((r) => {
      r.fit = Math.max(52, Math.min(98, Math.round(72 + (r.score - max) * 0.65)));
    });
    if (rows[0]) rows[0].fit = Math.min(98, Math.max(88, rows[0].fit));
    return { stop: null, results: rows.slice(0, 4) };
  }

  function scoreMaterials(state) {
    const rows = DATA.trotecMaterials.map((m) => {
      let score = m.active ? 12 : 2;
      const reasons = [];
      const cautions = [];

      if (state.materialProduct && m.applications.includes(state.materialProduct)) {
        score += 34;
        reasons.push('Designed for the selected end product/application');
      }
      if (state.materialEnvironment && state.materialEnvironment !== 'unsure') {
        if (m.environments.includes(state.materialEnvironment) || (state.materialEnvironment === 'harsh' && m.environments.includes('industrial'))) {
          score += 18;
          reasons.push(`Matches the ${state.materialEnvironment.replace('-', ' ')} environment requirement`);
        } else score -= 6;
      }
      if (state.materialAppearance && state.materialAppearance !== 'unsure') {
        if (m.appearances.includes(state.materialAppearance)) {
          score += 18;
          reasons.push('Matches the requested appearance / construction');
        } else if (state.materialAppearance === 'industrial' && ['durablack','trolase-metallic','trolase'].includes(m.id)) {
          score += 8;
        } else score -= 3;
      }
      if (state.materialProcess) {
        const materialProcesses = state.materialProcess === 'cut-engrave' ? ['cut','engrave'] : [state.materialProcess];
        if (materialProcesses.every((p) => m.processes.includes(p))) {
          score += 18;
          reasons.push(`Supports the selected ${state.materialProcess.replace('-', ' + ')} workflow`);
        } else score -= 10;
      }

      if (state.machine && state.machine !== 'none') {
        const machine = machineById(state.machine);
        if (machine) {
          const isCo2Material = m.processes.some((p) => ['cut','engrave'].includes(p)) || m.id === 'durablack';
          if (isCo2Material && machine.tech.includes('co2')) {
            score += 12;
            reasons.push(`Compatible technology direction with ${machine.name}`);
          } else if (isCo2Material && !machine.tech.includes('co2')) {
            score -= 25;
            cautions.push(`${machine.name} is not the primary technology for this material/process family.`);
          }
        }
      }

      // Explicit application nudges.
      if (state.materialProduct === 'durable-id' && m.id === 'durablack') score += 30;
      if (state.materialProduct === 'reverse-sign' && m.id === 'trolase-reverse') score += 30;
      if (state.materialProduct === 'ada-sign' && m.id === 'trolase-ada') score += 30;
      if (state.materialProduct === 'rubber-stamps' && m.id === 'laser-rubber') score += 35;
      if (state.materialAppearance === 'metallic' && m.id === 'trolase-metallic') score += 25;
      if (state.materialAppearance === 'thin' && ['trolase-thins','trolase-lights'].includes(m.id)) score += 20;
      if (state.materialAppearance === 'adhesive' && m.id === 'trolase-lights') score += 25;

      return { material: m, score, reasons: Array.from(new Set(reasons)).slice(0,4), cautions };
    }).sort((a,b) => b.score - a.score);

    const max = rows.length ? rows[0].score : 1;
    rows.forEach((r) => { r.fit = Math.max(54, Math.min(98, Math.round(90 + (r.score - max) * 0.55))); });
    if (rows[0]) rows[0].fit = Math.max(90, rows[0].fit);
    return rows.slice(0,4);
  }

  function stateSummary(state) {
    const industry = DATA.industries.find(i => i.id === state.industry)?.label;
    const app = applicationFor(state)?.label;
    const material = genericMaterial(state.material)?.label;
    const size = DATA.sizeOptions.concat(DATA.markSizeOptions || []).find(s => s.id === state.size)?.label;
    const volume = DATA.volumeOptions.find(v => v.id === state.volume)?.label;
    const lines = [];
    if (state.mode) lines.push(`Finder: ${state.mode === 'machine' ? 'Machine' : 'Material'}`);
    if (industry) lines.push(`Industry: ${industry}`);
    if (app) lines.push(`Application: ${app}`);
    if (material) lines.push(`Material: ${material}`);
    if (state.process) lines.push(`Primary process: ${state.process}`);
    if (size) lines.push(`Typical size: ${size}`);
    if (volume) lines.push(`Production: ${volume}`);
    if (state.priority) lines.push(`Priority: ${state.priority}`);
    if (state.requirements && state.requirements.length) lines.push(`Special requirements: ${state.requirements.join(', ')}`);
    if (state.materialProduct) lines.push(`Material use: ${DATA.materialFinder.productOptions.find(x => x.id === state.materialProduct)?.label || state.materialProduct}`);
    if (state.materialEnvironment) lines.push(`Environment: ${state.materialEnvironment}`);
    if (state.materialAppearance) lines.push(`Appearance: ${state.materialAppearance}`);
    if (state.materialProcess) lines.push(`Material process: ${state.materialProcess}`);
    if (state.machine && state.machine !== 'none') lines.push(`Existing machine: ${machineById(state.machine)?.name || state.machine}`);
    return lines.join('\n');
  }

  function extractionHtml(machine, state) {
    const mat = genericMaterial(state.material);
    const items = [];
    items.push(`<strong>${esc(machine.extraction.primary.join(' / '))}</strong>`);
    items.push(esc(machine.extraction.rule));
    if (mat && ['laser-rubber','acrylic'].includes(mat.id)) {
      items.push('Use approved fine-dust filtration and high-capacity activated carbon for the fume/odor load.');
    }
    if (mat && ['wood','mdf','paper'].includes(mat.id) && ['high','very-high'].includes(state.volume)) {
      items.push('High-volume coarse dust: add an approved pre-separator / VA5-style pre-filter before the main filter.');
    }
    if (machine.family === 'SP Series') {
      items.push('Large-format extraction is a specialist site-engineering item; standalone Atmos units are not the automatic recommendation path.');
    }
    return `<ul>${items.map(i => `<li>${i}</li>`).join('')}</ul>`;
  }

  function safetyHtml(state, machine) {
    const mat = genericMaterial(state.material);
    const messages = [];
    if (state.industry === 'education') messages.push('Education/FabLab: use an approved material library, supervision rules and documented SDS/TDS access.');
    if (mat) messages.push(mat.notes);
    messages.push('The result selects a machine/process direction; exact production settings should be validated by Trotec/Lawazen application testing.');
    if (machine && machine.class) messages.push(`Machine safety class/source note: ${machine.class}.`);
    return `<ul>${messages.map(m => `<li>${esc(m)}</li>`).join('')}</ul>`;
  }

  function choiceCard(choice, selected, inputType = 'radio') {
    const active = Array.isArray(selected) ? selected.includes(choice.value) : selected === choice.value;
    return `<button type="button" class="lz-choice${active ? ' is-selected' : ''}" data-choice="${esc(choice.value)}" aria-pressed="${active ? 'true' : 'false'}">
      ${choice.icon ? `<span class="lz-choice__icon">${icon(choice.icon)}</span>` : ''}
      <span class="lz-choice__body"><strong>${esc(choice.label)}</strong>${choice.description ? `<small>${esc(choice.description)}</small>` : ''}</span>
      <span class="lz-choice__mark">${active ? icon('check') : ''}</span>
    </button>`;
  }

  function machineQuestions(state) {
    const questions = [];
    questions.push({
      id: 'industry', title: 'What industry or environment will use the laser?',
      subtitle: 'This changes the recommendation logic, safety posture and workflow priorities.',
      choices: DATA.industries.map(i => ({ value: i.id, label: i.label, description: i.description, icon: i.icon }))
    });

    if (state.industry) {
      questions.push({
        id: 'application', title: 'What do you primarily want to make or do?',
        subtitle: 'Choose the closest production job. We use the actual job rather than matching a machine to an industry name alone.',
        choices: (DATA.applications[state.industry] || []).map(a => ({ value: a.id, label: a.label }))
      });
    }

    if (state.application) {
      const app = applicationFor(state);
      let ids = app && app.materials ? app.materials.slice() : ['acrylic','wood','stainless','aluminum','laminate','mixed'];
      if (ids.includes('sheet')) ids = ids.concat(['acrylic','wood','mdf']);
      if (ids.includes('mixed')) ids = ['acrylic','wood','mdf','laminate','anodized-aluminum','stainless','aluminum','engineered-plastic','mixed'];
      if (state.prefillMaterial) ids.push(state.prefillMaterial);
      ids = Array.from(new Set(ids.concat(['unknown','pvc'])));
      questions.push({
        id: 'material', title: 'What material will you process most often?',
        subtitle: 'Material identity is one of the strongest technology and safety gates.',
        choices: ids.map(id => genericMaterial(id)).filter(Boolean).map(m => ({ value: m.id, label: m.label, description: m.notes }))
      });
    }

    if (state.material) {
      questions.push({
        id: 'process', title: 'What do you need the laser to do?',
        subtitle: 'Cutting, engraving and direct industrial marking may require completely different laser sources.',
        choices: [
          { value: 'cut', label: 'Cut material', description: 'Through-cut sheet or part profiles.' },
          { value: 'engrave', label: 'Engrave', description: 'Remove/modify the surface to create text, graphics or depth.' },
          { value: 'cut-engrave', label: 'Cut + engrave', description: 'Both operations are important in the same workflow.' },
          { value: 'mark', label: 'Permanent direct marking', description: 'Direct mark on components, especially metals/plastics.' },
          { value: 'serialize', label: 'QR / Data Matrix / serial production', description: 'Variable data and industrial traceability.' },
          { value: 'mixed', label: 'A mix of fabrication + marking', description: 'You need more than one process family.' }
        ]
      });
    }

    if (state.process) {
      questions.push({
        id: 'size', title: 'What is the largest typical workpiece or sheet?',
        subtitle: 'A machine that cannot physically fit the job is eliminated before scoring.',
        choices: ((state.process === 'mark' || state.process === 'serialize') ? DATA.markSizeOptions : DATA.sizeOptions).map(s => ({ value: s.id, label: s.label, icon: 'ruler' }))
      });
    }

    if (state.size) {
      questions.push({
        id: 'volume', title: 'How will you use the machine?',
        subtitle: 'Production load helps distinguish a compact workstation from a high-throughput or automated system.',
        choices: DATA.volumeOptions.map(v => ({ value: v.id, label: v.label }))
      });
    }

    if (state.volume) {
      const special = [
        { value: 'students', label: 'Students / rotating users', description: 'Education deployment and supervision matter.' },
        { value: 'automation', label: 'PLC / database / automated workflow', description: 'Dynamic data, I/O or line integration.' },
        { value: 'printcut', label: 'Camera / Print & Cut', description: 'Registration to printed graphics matters.' },
        { value: 'rotary', label: 'Cylindrical / rotary work', description: 'Bottles, glasses and round objects.' },
        { value: 'mopa', label: 'MOPA specialty result', description: 'Sensitive plastics, controlled black effects or color-marking workflow.' }
      ];
      questions.push({
        id: 'requirements', title: 'Do any of these requirements apply?',
        subtitle: 'Select all that matter. You can also leave this blank.', multiselect: true,
        choices: special
      });
    }

    if (state.volume) {
      questions.push({
        id: 'priority', title: 'What matters most when two machines can do the job?',
        subtitle: 'This applies the engineering tie-break rules.',
        choices: [
          { value: 'balanced', label: 'Balanced overall fit' },
          { value: 'cutting-throughput', label: 'Cutting throughput' },
          { value: 'engraving-speed', label: 'Engraving productivity' },
          { value: 'value', label: 'Value / lower entry cost' },
          { value: 'automation', label: 'Automation & production integration' },
          { value: 'versatility', label: 'Maximum versatility' }
        ]
      });
    }

    return questions;
  }

  function materialQuestions(state) {
    const questions = [
      {
        id: 'materialProduct', title: 'What do you want to make?',
        subtitle: 'Start with the finished product rather than the Trotec material name.',
        choices: DATA.materialFinder.productOptions.map(o => ({ value: o.id, label: o.label }))
      }
    ];
    if (state.materialProduct) questions.push({
      id: 'materialEnvironment', title: 'Where will the finished product be used?',
      subtitle: 'Outdoor and harsh-industrial use can change the material family completely.',
      choices: DATA.materialFinder.environments.map(o => ({ value: o.id, label: o.label }))
    });
    if (state.materialEnvironment) questions.push({
      id: 'materialAppearance', title: 'What appearance or construction do you want?',
      subtitle: 'This helps distinguish metallic, reverse, thin, adhesive, acrylic and durable industrial materials.',
      choices: DATA.materialFinder.appearances.map(o => ({ value: o.id, label: o.label }))
    });
    if (state.materialAppearance) questions.push({
      id: 'materialProcess', title: 'How do you want to process it?',
      subtitle: 'The material must fit both the final product and the laser process.',
      choices: [
        { value: 'engrave', label: 'Engrave' },
        { value: 'cut', label: 'Cut' },
        { value: 'mark', label: 'Mark' },
        { value: 'cut-engrave', label: 'Cut + engrave', description: 'We will prioritize families supporting both.' }
      ]
    });
    if (state.materialProcess) {
      const machineChoices = [{ value: 'none', label: 'I do not have a machine / not sure' }].concat(
        DATA.machines.filter(m => m.active).map(m => ({ value: m.id, label: m.name, description: m.tech.join(' + ').toUpperCase() }))
      );
      questions.push({
        id: 'machine', title: 'Do you already own or plan to use a specific Trotec machine?',
        subtitle: 'Optional, but it lets the Material Finder check the technology direction.',
        choices: machineChoices
      });
    }
    return questions;
  }

  class Wizard {
    constructor(root) {
      this.root = root;
      this.state = loadState();
      this.state.mode = this.state.mode || root.dataset.defaultMode || '';
      this.step = 0;
      this.track = $('.lz-wizard__track', root);
      this.progress = $('.lz-wizard__progress-bar', root);
      this.stepLabel = $('.lz-wizard__step-label', root);
      this.backBtn = $('[data-wizard-back]', root);
      this.nextBtn = $('[data-wizard-next]', root);
      this.restartBtn = $('[data-wizard-restart]', root);
      this.modePanel = $('.lz-wizard__mode', root);
      this.questionPanel = $('.lz-wizard__question', root);
      this.resultPanel = $('.lz-wizard__results', root);
      this.contactPanel = $('.lz-wizard__contact', root);
      this.bind();
      this.syncFromState();
      this.render();
      if ($('.lz-form-status', root)) {
        this.contactPanel.hidden = false;
        this.populateContactSummary();
      }
    }

    bind() {
      this.root.addEventListener('click', (e) => {
        const mode = e.target.closest('[data-mode]');
        if (mode) {
          this.setMode(mode.dataset.mode);
          return;
        }
        const choice = e.target.closest('[data-choice]');
        if (choice && this.currentQuestion) {
          const id = this.currentQuestion.id;
          const value = choice.dataset.choice;
          if (this.currentQuestion.multiselect) {
            const list = Array.isArray(this.state[id]) ? this.state[id].slice() : [];
            const ix = list.indexOf(value);
            if (ix >= 0) list.splice(ix,1); else list.push(value);
            this.state[id] = list;
          } else {
            this.state[id] = value;
            this.clearDownstream(id);
            if (id === 'application' && this.state.prefillMaterial) this.state.material = this.state.prefillMaterial;
            if (id === 'materialProcess' && this.state.prefillMachine) this.state.machine = this.state.prefillMachine;
          }
          saveState(this.state);
          this.renderQuestion();
          return;
        }
        const cross = e.target.closest('[data-cross-mode]');
        if (cross) {
          const mode = cross.dataset.crossMode;
          const material = cross.dataset.material || '';
          const machine = cross.dataset.machine || '';
          this.state.mode = mode;
          if (mode === 'machine' && material) {
            this.state.prefillMaterial = material;
            delete this.state.industry; delete this.state.application; delete this.state.material; delete this.state.process; delete this.state.size; delete this.state.volume; delete this.state.requirements; delete this.state.priority;
          }
          if (mode === 'material' && machine) {
            this.state.prefillMachine = machine;
            this.state.materialProduct = this.crossMaterialProduct(this.state.application) || this.state.materialProduct || '';
            delete this.state.materialEnvironment; delete this.state.materialAppearance; delete this.state.materialProcess; delete this.state.machine;
          }
          this.step = 0;
          saveState(this.state);
          this.render();
          window.scrollTo({ top: this.root.getBoundingClientRect().top + window.scrollY - 100, behavior: 'smooth' });
          return;
        }
        const showContact = e.target.closest('[data-show-contact]');
        if (showContact) {
          this.contactPanel.hidden = false;
          this.populateContactSummary();
          this.contactPanel.scrollIntoView({ behavior: 'smooth', block: 'start' });
          return;
        }
      });

      this.backBtn && this.backBtn.addEventListener('click', () => {
        if (this.step > 0) this.step -= 1;
        else if (this.state.mode) this.state.mode = '';
        this.render();
      });
      this.nextBtn && this.nextBtn.addEventListener('click', () => this.next());
      this.restartBtn && this.restartBtn.addEventListener('click', () => this.restart());
    }

    setMode(mode) {
      this.state = { mode };
      this.step = 0;
      saveState(this.state);
      this.render();
    }

    restart() {
      const mode = this.state.mode;
      this.state = { mode };
      this.step = 0;
      saveState(this.state);
      this.contactPanel.hidden = true;
      this.render();
    }

    syncFromState() {
      if (!this.state.mode) return;
      const qs = this.questions();
      let completed = 0;
      for (const q of qs) {
        if (q.multiselect) {
          if (this.state[q.id] !== undefined) completed += 1; else break;
        } else if (this.state[q.id]) completed += 1; else break;
      }
      this.step = Math.min(completed, qs.length);
    }

    clearDownstream(id) {
      const order = this.state.mode === 'material'
        ? ['materialProduct','materialEnvironment','materialAppearance','materialProcess','machine']
        : ['industry','application','material','process','size','volume','requirements','priority'];
      const ix = order.indexOf(id);
      if (ix < 0) return;
      order.slice(ix + 1).forEach((key) => delete this.state[key]);
    }

    questions() {
      return this.state.mode === 'material' ? materialQuestions(this.state) : machineQuestions(this.state);
    }

    next() {
      const qs = this.questions();
      if (this.step >= qs.length) return;
      const q = qs[this.step];
      if (q.multiselect && this.state[q.id] === undefined) this.state[q.id] = [];
      const value = this.state[q.id];
      if (!q.multiselect && !value) {
        this.questionPanel.classList.add('lz-shake');
        setTimeout(() => this.questionPanel.classList.remove('lz-shake'), 300);
        return;
      }
      saveState(this.state);
      this.step += 1;
      this.render();
    }

    render() {
      const hasMode = !!this.state.mode;
      this.modePanel.hidden = hasMode;
      this.questionPanel.hidden = !hasMode;
      this.resultPanel.hidden = true;
      this.contactPanel.hidden = true;

      if (!hasMode) {
        this.backBtn.hidden = true;
        this.nextBtn.hidden = true;
        this.restartBtn.hidden = true;
        this.progress.style.width = '0%';
        this.stepLabel.textContent = 'Choose a finder';
        return;
      }

      const qs = this.questions();
      if (this.step >= qs.length) {
        this.renderResults();
        return;
      }

      this.currentQuestion = qs[this.step];
      const pct = Math.round(((this.step + 1) / qs.length) * 100);
      this.progress.style.width = `${pct}%`;
      this.stepLabel.textContent = `${this.step + 1} / ${qs.length}`;
      this.backBtn.hidden = false;
      this.nextBtn.hidden = false;
      this.restartBtn.hidden = false;
      this.nextBtn.textContent = T.continue;
      this.renderQuestion();
    }

    renderQuestion() {
      const q = this.currentQuestion;
      if (!q) return;
      const selected = this.state[q.id];
      this.questionPanel.innerHTML = `
        <div class="lz-question__head">
          <p class="lz-eyebrow">${this.state.mode === 'machine' ? 'FIND MY MACHINE' : 'FIND MY MATERIAL'}</p>
          <h2>${esc(q.title)}</h2>
          <p>${esc(q.subtitle || '')}</p>
          ${q.multiselect ? `<span class="lz-optional">${T.optional}</span>` : ''}
        </div>
        <div class="lz-choice-grid ${q.choices.length > 8 ? 'is-dense' : ''}" role="group">
          ${q.choices.map(c => choiceCard(c, selected, q.multiselect ? 'checkbox' : 'radio')).join('')}
        </div>`;
    }

    renderResults() {
      this.questionPanel.hidden = true;
      this.resultPanel.hidden = false;
      this.backBtn.hidden = false;
      this.nextBtn.hidden = true;
      this.restartBtn.hidden = false;
      this.progress.style.width = '100%';
      this.stepLabel.textContent = T.results;

      if (this.state.mode === 'machine') this.renderMachineResults();
      else this.renderMaterialResults();
    }

    renderMachineResults() {
      const { stop, results } = scoreMachines(this.state);
      if (stop) {
        this.resultPanel.innerHTML = `
          <div class="lz-stop lz-stop--${esc(stop.type)}">
            ${icon('alert')}
            <p class="lz-eyebrow">${T.specialist}</p>
            <h2>${esc(stop.title)}</h2>
            <p>${esc(stop.body)}</p>
            <div class="lz-result-actions"><button type="button" class="lz-btn lz-btn--primary" data-show-contact>${T.request}</button></div>
          </div>
          <div class="lz-summary"><h3>${T.answerSummary}</h3><pre>${esc(stateSummary(this.state))}</pre></div>`;
        return;
      }

      if (!results.length) {
        this.resultPanel.innerHTML = `<div class="lz-stop"><h2>${T.specialist}</h2><p>We could not produce a responsible automatic recommendation from this combination. Send the application to Lawazen for review.</p><button type="button" class="lz-btn lz-btn--primary" data-show-contact>${T.request}</button></div>`;
        return;
      }

      const top = results[0];
      const m = top.machine;
      const materialCross = this.crossMaterialId(this.state.material);
      this.resultPanel.innerHTML = `
        <div class="lz-result-hero">
          <div class="lz-result-hero__main">
            <p class="lz-eyebrow">${T.bestMatch}</p>
            <div class="lz-result-title-row"><h2>${esc(m.name)}</h2><span class="lz-fit">${top.fit}% ${T.fit}</span></div>
            <p class="lz-result-subtitle">${esc(m.family)} · ${esc(m.tech.join(' + ').toUpperCase())} · ${esc(m.areaLabel)}</p>
            <div class="lz-meter"><span style="width:${top.fit}%"></span></div>
            <div class="lz-tags">
              <span>${esc(m.power)}</span><span>${esc(m.class)}</span><span>${m.active ? T.active : T.availability}</span>
            </div>
            <h3>${T.why}</h3>
            <ul class="lz-check-list">${top.reasons.map(r => `<li>${icon('check')}<span>${esc(r)}</span></li>`).join('')}</ul>
            ${top.cautions.length ? `<div class="lz-callout lz-callout--warning">${top.cautions.map(c => `<p>${esc(c)}</p>`).join('')}</div>` : ''}
            ${this.state.process === 'mixed' ? `<div class="lz-callout lz-callout--warning"><p><strong>Mixed laser-source workflow:</strong> your answers span CO₂ fabrication and direct fiber marking. Ask Lawazen to configure a Speedy flexx where the exact model is available, or pair the recommended CO₂ machine with a U/SpeedMarker workstation. A standard CO₂ configuration alone is not a direct bare-metal marking solution.</p></div>` : ''}
          </div>
          <div class="lz-result-hero__side">
            <div class="lz-machine-visual"><span>${icon('laser')}</span><strong>${esc(m.name)}</strong><small>${esc(m.family)}</small></div>
            <a class="lz-btn lz-btn--primary" href="${esc(m.productUrl)}">${T.viewProduct} ${icon('arrow')}</a>
            <a class="lz-btn lz-btn--ghost" href="${esc(m.docsUrl)}" target="_blank" rel="noopener">${T.officialDocs}</a>
            <button type="button" class="lz-btn lz-btn--dark" data-show-contact>${T.request}</button>
          </div>
        </div>

        <div class="lz-result-columns">
          <section class="lz-info-card"><div class="lz-info-card__icon">${icon('factory')}</div><h3>${T.extraction}</h3>${extractionHtml(m, this.state)}</section>
          <section class="lz-info-card"><div class="lz-info-card__icon">${icon('shield')}</div><h3>${T.safety}</h3>${safetyHtml(this.state, m)}</section>
        </div>

        ${materialCross ? `<div class="lz-crosslink"><div><p class="lz-eyebrow">CONNECTED FINDER</p><h3>${T.findMaterials}</h3><p>Keep this application and machine context, then narrow the Trotec material family.</p></div><button type="button" class="lz-btn lz-btn--primary" data-cross-mode="material" data-machine="${esc(m.id)}" data-material="${esc(materialCross)}">${T.findMaterials} ${icon('arrow')}</button></div>` : ''}

        <div class="lz-alternatives">
          <div class="lz-section-head"><p class="lz-eyebrow">COMPARE</p><h3>${T.alternatives}</h3></div>
          <div class="lz-alt-grid">${results.slice(1,4).map(r => this.machineAltCard(r)).join('')}</div>
        </div>

        <div class="lz-summary"><h3>${T.answerSummary}</h3><pre>${esc(stateSummary(this.state))}</pre></div>`;
      this.populateContactSummary(`${m.name} (${top.fit}% fit)`);
    }

    machineAltCard(row) {
      const m = row.machine;
      return `<article class="lz-alt-card">
        <div class="lz-alt-card__top"><span>${esc(m.family)}</span><strong>${row.fit}%</strong></div>
        <h4>${esc(m.name)}</h4>
        <p>${esc(m.areaLabel)} · ${esc(m.tech.join(' + ').toUpperCase())}</p>
        <ul>${row.reasons.slice(0,2).map(r => `<li>${esc(r)}</li>`).join('')}</ul>
        <a href="${esc(m.productUrl)}">${T.viewProduct} ${icon('arrow')}</a>
      </article>`;
    }

    renderMaterialResults() {
      const results = scoreMaterials(this.state);
      const top = results[0];
      if (!top) return;
      const m = top.material;
      this.resultPanel.innerHTML = `
        <div class="lz-result-hero lz-result-hero--material">
          <div class="lz-result-hero__main">
            <p class="lz-eyebrow">${T.bestMatch}</p>
            <div class="lz-result-title-row"><h2>${esc(m.name)}</h2><span class="lz-fit">${top.fit}% ${T.fit}</span></div>
            <p class="lz-result-subtitle">${esc(m.base)} · ${esc(m.thickness)}</p>
            <div class="lz-meter"><span style="width:${top.fit}%"></span></div>
            <div class="lz-tags"><span>${esc(m.status)}</span><span>${esc(m.processes.join(' + '))}</span><span>${esc(m.environments.join(' / '))}</span></div>
            <h3>${T.why}</h3>
            <ul class="lz-check-list">${top.reasons.concat(m.why).slice(0,5).map(r => `<li>${icon('check')}<span>${esc(r)}</span></li>`).join('')}</ul>
          </div>
          <div class="lz-result-hero__side">
            <div class="lz-material-swatch" style="--swatch:${esc(m.swatch)}"><span></span><strong>${esc(m.name)}</strong><small>${esc(m.status)}</small></div>
            <a class="lz-btn lz-btn--primary" href="${esc(m.productUrl)}">${T.viewProduct} ${icon('arrow')}</a>
            <a class="lz-btn lz-btn--ghost" href="${esc(m.tdsUrl)}" target="_blank" rel="noopener">TDS / ${T.documents}</a>
            <a class="lz-btn lz-btn--ghost" href="${esc(m.sdsUrl)}" target="_blank" rel="noopener">SDS / ${T.safety}</a>
            <button type="button" class="lz-btn lz-btn--dark" data-show-contact>${T.request}</button>
          </div>
        </div>

        <div class="lz-result-columns">
          <section class="lz-info-card"><div class="lz-info-card__icon">${icon('material')}</div><h3>Material profile</h3><p>${esc(m.base)}</p><p><strong>Typical thickness:</strong> ${esc(m.thickness)}</p></section>
          <section class="lz-info-card"><div class="lz-info-card__icon">${icon('shield')}</div><h3>${T.safety}</h3><p>${esc(m.safety)}</p></section>
        </div>

        <div class="lz-crosslink"><div><p class="lz-eyebrow">CONNECTED FINDER</p><h3>${T.findMachine}</h3><p>Carry this material/application into the machine finder so you do not answer the same questions twice.</p></div><button type="button" class="lz-btn lz-btn--primary" data-cross-mode="machine" data-material="${esc(this.crossGenericId(m.id))}">${T.findMachine} ${icon('arrow')}</button></div>

        <div class="lz-alternatives"><div class="lz-section-head"><p class="lz-eyebrow">COMPARE</p><h3>${T.alternatives}</h3></div><div class="lz-alt-grid">${results.slice(1,4).map(r => this.materialAltCard(r)).join('')}</div></div>
        <div class="lz-summary"><h3>${T.answerSummary}</h3><pre>${esc(stateSummary(this.state))}</pre></div>`;
      this.populateContactSummary(`${m.name} (${top.fit}% fit)`);
    }

    materialAltCard(row) {
      const m = row.material;
      return `<article class="lz-alt-card lz-alt-card--material">
        <div class="lz-mini-swatch" style="--swatch:${esc(m.swatch)}"></div>
        <div class="lz-alt-card__top"><span>${esc(m.status)}</span><strong>${row.fit}%</strong></div>
        <h4>${esc(m.name)}</h4><p>${esc(m.base)}</p>
        <a href="${esc(m.productUrl)}">${T.viewProduct} ${icon('arrow')}</a>
      </article>`;
    }

    crossMaterialProduct(applicationId) {
      const direct = DATA.materialFinder.productOptions.find(o => o.id === applicationId);
      if (direct) return direct.id;
      const map = {
        'stamp-production':'rubber-stamps','rubber-stamps':'rubber-stamps',
        'industrial-labels':'industrial-labels','control-panels':'industrial-labels','mro':'durable-id','durable-id':'durable-id',
        'large-sign':'outdoor-sign','outdoor-sign':'outdoor-sign','indoor-sign':'indoor-sign','reverse-sign':'reverse-sign','ada-sign':'ada-sign',
        'architecture-lab':'architecture-lab','product-design':'architecture-lab','awards':'awards','gifts':'awards','name-badges':'name-badges'
      };
      return map[applicationId] || '';
    }

    crossMaterialId(genericId) {
      const map = {
        'trolase':'trolase','trolase-metallic':'trolase-metallic','laser-rubber':'laser-rubber','durablack':'durablack',
        'acrylic':'troglass','laminate':'trolase','wood':'trowood','mdf':'trowood','plywood':'trowood'
      };
      return map[genericId] || '';
    }

    crossGenericId(materialId) {
      const map = {
        'trolase':'trolase','trolase-metallic':'trolase-metallic','trolase-thins':'laminate','trolase-lights':'laminate',
        'trolase-reverse':'trolase-reverse','trolase-ada':'trolase-ada','troglass':'acrylic','durablack':'durablack',
        'laser-rubber':'laser-rubber','trowood':'wood'
      };
      return map[materialId] || 'mixed';
    }

    populateContactSummary(recommendation = '') {
      const textarea = $('[data-contact-summary]', this.root);
      if (!textarea) return;
      const rec = recommendation ? `\n\nWizard recommendation: ${recommendation}` : '';
      textarea.value = `${stateSummary(this.state)}${rec}\n\nPlease review this application and contact me with the recommended Trotec configuration.`;
    }
  }

  function initEntry(root) {
    if (root.dataset.lzInitialized === 'true') return;
    root.dataset.lzInitialized = 'true';
    const modeButtons = $$('[data-entry-mode]', root);
    const industrySelect = $('[data-entry-industry]', root);
    const detailSelect = $('[data-entry-detail]', root);
    const startBtn = $('[data-entry-start]', root);
    const finderUrl = root.dataset.finderUrl || '/pages/trotec-solution-finder';
    let mode = root.dataset.defaultMode || 'machine';

    function setMode(next) {
      mode = next;
      modeButtons.forEach(b => {
        const active = b.dataset.entryMode === mode;
        b.classList.toggle('is-selected', active);
        b.setAttribute('aria-pressed', active ? 'true' : 'false');
      });
      renderDetails();
    }

    function renderDetails() {
      const industry = industrySelect.value;
      const options = mode === 'machine'
        ? ((industry && DATA.applications[industry]) ? DATA.applications[industry].map(o => [o.id,o.label]) : [])
        : DATA.materialFinder.productOptions.map(o => [o.id,o.label]);
      const placeholder = mode === 'machine'
        ? (industry ? 'Primary application' : 'Choose an industry first')
        : 'What are you making?';
      detailSelect.innerHTML = `<option value="">${placeholder}</option>` + options.map(([v,l]) => `<option value="${esc(v)}">${esc(l)}</option>`).join('');
      detailSelect.disabled = mode === 'machine' && !industry;
    }

    modeButtons.forEach(b => b.addEventListener('click', () => setMode(b.dataset.entryMode)));
    industrySelect.innerHTML = `<option value="">Industry</option>` + DATA.industries.map(i => `<option value="${esc(i.id)}">${esc(i.label)}</option>`).join('');
    industrySelect.addEventListener('change', renderDetails);
    startBtn.addEventListener('click', () => {
      const p = new URLSearchParams();
      p.set('mode', mode);
      if (industrySelect.value) p.set('industry', industrySelect.value);
      if (detailSelect.value) {
        if (mode === 'machine') p.set('application', detailSelect.value);
        else p.set('materialProduct', detailSelect.value);
      }
      window.location.href = `${finderUrl}${finderUrl.includes('?') ? '&' : '?'}${p.toString()}`;
    });
    setMode(mode);
  }

  window.LawazenTrotecFinderTest = { scoreMachines, scoreMaterials, hardStop, stateSummary };

  function init() {
    $$('[data-lz-trotec-entry]').forEach(initEntry);
    $$('[data-lz-trotec-wizard]').forEach(root => { if (root.dataset.lzInitialized !== 'true') { root.dataset.lzInitialized = 'true'; new Wizard(root); } });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
